import { useState } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';

const HowItWorksPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Stop Missing Calls. Start Capturing Customers.",
      subtitle: "ReceptionGenie answers, qualifies, and books customers for you — 24/7.",
      image: "https://public.readdy.ai/ai/img_res/89eea2007a96065d21eed177286fc044.jpg"
    },
    {
      id: 2,
      title: "Missed Calls = Lost Revenue",
      points: [
        "Missed calls go to competitors",
        "Slow callbacks kill conversions",
        "Staff can't answer 24/7"
      ],
      image: "https://readdy.ai/api/search-image?query=frustrated%20business%20owner%20looking%20at%20smartphone%20with%20multiple%20missed%20call%20notifications%20fading%20dollar%20signs%20floating%20away%20in%20background%20modern%20office%20setting%20with%20pink%20purple%20lighting%20professional%20editorial%20photography%20cinematic%20depth%20of%20field%20soft%20glow%20effects%20representing%20lost%20revenue%20and%20opportunities%20premium%20business%20aesthetic&width=1200&height=675&seq=howitworks02&orientation=landscape"
    },
    {
      id: 3,
      title: "What Is ReceptionGenie?",
      subtitle: "An AI receptionist that answers calls, qualifies leads, and books appointments automatically.",
      image: "https://readdy.ai/api/search-image?query=professional%20AI%20genie%20character%20wearing%20modern%20wireless%20headset%20surrounded%20by%20floating%20holographic%20interface%20elements%20with%20call%20icons%20appointment%20calendars%20and%20digital%20screens%20in%20sleek%20modern%20workspace%20with%20purple%20pink%20teal%20gradient%20lighting%20futuristic%20technology%20aesthetic%20clean%20professional%20design%20editorial%20style%20photography&width=1200&height=675&seq=howitworks03&orientation=landscape"
    },
    {
      id: 4,
      title: "Speed Wins Every Time",
      points: [
        "First response wins the customer",
        "Minutes matter in lead conversion"
      ],
      image: "https://readdy.ai/api/search-image?query=dynamic%20racing%20stopwatch%20with%20glowing%20numbers%20and%20speed%20motion%20blur%20effects%20showing%20competing%20businesses%20racing%20for%20customer%20attention%20with%20purple%20pink%20gradient%20lighting%20modern%20professional%20setting%20with%20floating%20clock%20elements%20and%20urgency%20indicators%20premium%20editorial%20photography%20cinematic%20lighting%20soft%20glow%20accents&width=1200&height=675&seq=howitworks04&orientation=landscape"
    },
    {
      id: 5,
      title: "How ReceptionGenie Works",
      steps: [
        "Call comes in",
        "AI answers instantly",
        "Lead is qualified",
        "Appointment booked or call routed"
      ],
      image: "https://readdy.ai/api/search-image?query=clean%20modern%20flowchart%20diagram%20showing%20four%20connected%20steps%20with%20glowing%20icons%20for%20incoming%20phone%20call%20AI%20answering%20lead%20qualification%20and%20appointment%20booking%20with%20arrows%20connecting%20each%20stage%20in%20professional%20workspace%20with%20purple%20pink%20teal%20gradient%20lighting%20holographic%20interface%20elements%20premium%20SaaS%20design%20aesthetic&width=1200&height=675&seq=howitworks05&orientation=landscape"
    },
    {
      id: 6,
      title: "AI Answers Every Call",
      points: [
        "24/7 availability",
        "Natural conversation",
        "No missed calls"
      ],
      image: "https://readdy.ai/api/search-image?query=modern%20smartphone%20ringing%20with%20glowing%20notification%20and%20friendly%20AI%20genie%20character%20answering%20the%20call%20with%20floating%20speech%20bubbles%20showing%20natural%20conversation%20in%20professional%20office%20environment%20with%20purple%20pink%20gradient%20lighting%20holographic%20call%20interface%20elements%20premium%20editorial%20style%20cinematic%20depth%20of%20field&width=1200&height=675&seq=howitworks06&orientation=landscape"
    },
    {
      id: 7,
      title: "Only Real Buyers Reach You",
      points: [
        "Filters spam automatically",
        "Detects genuine intent",
        "Asks smart qualifying questions"
      ],
      image: "https://readdy.ai/api/search-image?query=digital%20filtering%20system%20with%20green%20checkmarks%20for%20qualified%20leads%20and%20red%20X%20marks%20filtering%20out%20spam%20calls%20with%20AI%20interface%20analyzing%20caller%20intent%20in%20modern%20workspace%20with%20purple%20pink%20teal%20gradient%20lighting%20holographic%20screening%20elements%20premium%20technology%20aesthetic%20editorial%20photography%20style&width=1200&height=675&seq=howitworks07&orientation=landscape"
    },
    {
      id: 8,
      title: "Appointments Booked Automatically",
      points: [
        "Syncs with your calendar",
        "Instant confirmations sent",
        "Zero manual scheduling"
      ],
      image: "https://readdy.ai/api/search-image?query=modern%20digital%20calendar%20interface%20with%20appointments%20being%20automatically%20added%20with%20glowing%20confirmation%20checkmarks%20and%20sync%20icons%20in%20professional%20workspace%20with%20purple%20pink%20gradient%20lighting%20holographic%20scheduling%20elements%20floating%20around%20premium%20SaaS%20design%20aesthetic%20cinematic%20lighting%20editorial%20style&width=1200&height=675&seq=howitworks08&orientation=landscape"
    },
    {
      id: 9,
      title: "Boost Your Conversion Rate",
      metrics: [
        "More leads captured",
        "More appointments booked",
        "Higher close rates"
      ],
      image: "https://readdy.ai/api/search-image?query=upward%20trending%20business%20growth%20charts%20and%20graphs%20with%20glowing%20success%20indicators%20showing%20increasing%20conversion%20rates%20and%20revenue%20metrics%20in%20modern%20professional%20setting%20with%20purple%20pink%20teal%20gradient%20lighting%20holographic%20data%20visualization%20elements%20premium%20editorial%20photography%20cinematic%20style&width=1200&height=675&seq=howitworks09&orientation=landscape"
    },
    {
      id: 10,
      title: "Built for Real Businesses",
      examples: [
        "Home services &amp; contractors",
        "Medical &amp; dental practices",
        "Local service businesses"
      ],
      image: "https://readdy.ai/api/search-image?query=diverse%20collection%20of%20business%20icons%20representing%20home%20services%20medical%20practices%20and%20local%20businesses%20arranged%20in%20modern%20professional%20layout%20with%20purple%20pink%20gradient%20lighting%20clean%20minimalist%20design%20with%20soft%20glow%20effects%20premium%20SaaS%20aesthetic%20editorial%20style%20photography&width=1200&height=675&seq=howitworks10&orientation=landscape"
    },
    {
      id: 11,
      title: "Up and Running Fast",
      steps: [
        "Connect your phone number",
        "Customize AI responses",
        "Go live in minutes"
      ],
      image: "https://readdy.ai/api/search-image?query=rocket%20launching%20upward%20with%20glowing%20trail%20representing%20fast%20setup%20and%20quick%20deployment%20with%20floating%20setup%20icons%20and%20configuration%20elements%20in%20modern%20workspace%20with%20purple%20pink%20teal%20gradient%20lighting%20dynamic%20motion%20and%20energy%20premium%20editorial%20photography%20cinematic%20style&width=1200&height=675&seq=howitworks11&orientation=landscape"
    },
    {
      id: 12,
      title: "Works While You Don't",
      points: [
        "Nights &amp; weekends covered",
        "Holidays handled",
        "Always available for customers"
      ],
      image: "https://readdy.ai/api/search-image?query=glowing%2024%207%20clock%20display%20showing%20continuous%20operation%20through%20day%20and%20night%20with%20moon%20and%20sun%20symbols%20in%20modern%20professional%20setting%20with%20purple%20pink%20gradient%20lighting%20representing%20always%20on%20availability%20and%20reliability%20premium%20editorial%20style%20cinematic%20lighting%20soft%20glow%20effects&width=1200&height=675&seq=howitworks12&orientation=landscape"
    },
    {
      id: 13,
      title: "Hear ReceptionGenie in Action",
      cta: "Call the live AI demo anytime",
      phone: "+1 (888) 600-9252",
      image: "https://readdy.ai/api/search-image?query=friendly%20AI%20genie%20character%20gesturing%20invitation%20to%20call%20with%20large%20glowing%20phone%20icon%20and%20visible%20phone%20number%20in%20modern%20professional%20workspace%20with%20purple%20pink%20gradient%20lighting%20welcoming%20atmosphere%20premium%20editorial%20photography%20cinematic%20style%20soft%20depth%20of%20field&width=1200&height=675&seq=howitworks13&orientation=landscape"
    },
    {
      id: 14,
      title: "Never Miss Another Opportunity",
      subtitle: "ReceptionGenie.ai — your always-on AI receptionist.",
      image: "https://readdy.ai/api/search-image?query=elegant%20receptiongenie%20brand%20finish%20with%20professional%20AI%20genie%20mascot%20character%20and%20clean%20logo%20presentation%20in%20premium%20modern%20workspace%20with%20purple%20pink%20gradient%20lighting%20minimalist%20design%20soft%20glow%20effects%20memorable%20closing%20visual%20editorial%20style%20photography%20cinematic%20lighting&width=1200&height=675&seq=howitworks14&orientation=landscape"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-pink-50 to-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Pacifico', serif" }}>
            How It Works
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See exactly how ReceptionGenie.ai answers calls, qualifies leads, and converts customers automatically.
          </p>
        </div>
      </section>

      {/* Slideshow Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {/* Slideshow Container */}
          <div className="relative max-w-6xl mx-auto">
            {/* Main Slide Display */}
            <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden">
              {/* Slide Image */}
              <div className="relative aspect-video w-full overflow-hidden">
                <img
                  src={slides[currentSlide].image}
                  alt={slides[currentSlide].title}
                  className="w-full h-full object-cover"
                />
                
                {/* Overlay Content */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex flex-col justify-end p-8 lg:p-12">
                  <div className="text-white space-y-4">
                    <h3 className="text-3xl lg:text-4xl font-bold leading-tight">
                      {slides[currentSlide].title}
                    </h3>
                    
                    {slides[currentSlide].subtitle && (
                      <p className="text-lg lg:text-xl text-white/90 max-w-3xl">
                        {slides[currentSlide].subtitle}
                      </p>
                    )}
                    
                    {slides[currentSlide].points && (
                      <ul className="space-y-2 mt-4">
                        {slides[currentSlide].points.map((point, idx) => (
                          <li key={idx} className="flex items-start gap-3">
                            <i className="ri-check-line text-pink-400 text-xl flex-shrink-0 mt-1"></i>
                            <span className="text-white/90">{point}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                    
                    {slides[currentSlide].steps && (
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                        {slides[currentSlide].steps.map((step, idx) => (
                          <div key={idx} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3">
                            <div className="w-8 h-8 bg-pink-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                              {idx + 1}
                            </div>
                            <span className="text-white/90 text-sm">{step}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    {slides[currentSlide].metrics && (
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
                        {slides[currentSlide].metrics.map((metric, idx) => (
                          <div key={idx} className="bg-gradient-to-br from-pink-500/20 to-purple-500/20 backdrop-blur-sm rounded-lg px-4 py-3 text-center border border-white/20">
                            <i className="ri-arrow-up-line text-green-400 text-2xl mb-1"></i>
                            <p className="text-white/90 text-sm font-semibold">{metric}</p>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    {slides[currentSlide].examples && (
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
                        {slides[currentSlide].examples.map((example, idx) => (
                          <div key={idx} className="bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 text-center border border-white/20">
                            <p className="text-white/90 text-sm font-semibold" dangerouslySetInnerHTML={{ __html: example }}></p>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    {slides[currentSlide].cta && (
                      <div className="mt-6 bg-gradient-to-r from-pink-500/20 to-purple-500/20 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                        <p className="text-white/90 text-lg mb-3">{slides[currentSlide].cta}</p>
                        <a 
                          href={`tel:${slides[currentSlide].phone?.replace(/\D/g, '')}`}
                          className="inline-flex items-center gap-3 bg-white text-gray-900 px-6 py-3 rounded-full font-bold text-xl hover:bg-pink-50 transition-all whitespace-nowrap"
                        >
                          <i className="ri-phone-fill text-pink-600"></i>
                          {slides[currentSlide].phone}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 cursor-pointer z-10"
                aria-label="Previous slide"
              >
                <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
              </button>
              
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 cursor-pointer z-10"
                aria-label="Next slide"
              >
                <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
              </button>
            </div>

            {/* Slide Indicators */}
            <div className="flex items-center justify-center gap-2 mt-8 flex-wrap">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`transition-all cursor-pointer ${
                    index === currentSlide
                      ? 'w-12 h-3 bg-gradient-to-r from-pink-500 to-purple-500'
                      : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
                  } rounded-full`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {/* Slide Counter */}
            <div className="text-center mt-4">
              <span className="text-gray-600 font-semibold">
                {currentSlide + 1} / {slides.length}
              </span>
            </div>
          </div>

          {/* Bottom CTA */}
          <div className="mt-16 text-center">
            <a
              href="/payment"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-xl transition-all hover:scale-105 whitespace-nowrap"
            >
              Get Started Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HowItWorksPage;
